import { Download } from "lucide-react";

const TXT = {
  da: { btn: "Gem som PDF", hint: "Vælg 'Gem som PDF' som printer" },
  en: { btn: "Save as PDF", hint: "Choose 'Save as PDF' as the printer" },
  ar: { btn: "حفظ بصيغة PDF", hint: "اختر 'حفظ بصيغة PDF' كطابعة" },
};

export function PrintButton({ filename, lang = "da", className = "" }) {
  const t = TXT[lang] || TXT.da;
  const onClick = () => {
    const prev = document.title;
    document.title = filename ? `BSM – ${filename}` : prev;
    const restore = () => { document.title = prev; window.removeEventListener("afterprint", restore); };
    window.addEventListener("afterprint", restore);
    setTimeout(() => window.print(), 50);
    setTimeout(restore, 60000);
  };
  return (
    <div className={`no-print flex items-center gap-3 ${className}`} data-testid="print-button-wrap">
      <button type="button" onClick={onClick} data-testid="print-button" className="inline-flex items-center gap-2 text-sm font-medium px-3.5 py-2 rounded-full border bg-white hover:bg-[#F3F1EC] transition-colors" style={{ borderColor: "#EBE8E3", color: "#806B61" }}>
        <Download className="h-4 w-4" strokeWidth={1.75} /> {t.btn}
      </button>
      <span className="text-xs hidden sm:inline" style={{ color: "#A8A29E" }} data-testid="print-button-hint">{t.hint}</span>
    </div>
  );
}
